import { takeEvery, call, put, all, fork, select } from 'redux-saga/effects';
import { GET_DATA_BLOG, actionCreators } from './action';

import agreement_PL from '../../translations/pl_PL/blog/agreement.json';
import colorTheory_PL from '../../translations/pl_PL/blog/colorTheory.json';
import effectiveCommunication_PL from '../../translations/pl_PL/blog/effectiveCommunication.json';
import howInterprateResult_PL from '../../translations/pl_PL/blog/howInterprateResult.json';
import manipulation_PL from '../../translations/pl_PL/blog/manipulation.json';
import privacy_policy_PL from '../../translations/pl_PL/blog/privacy-policy.json';
import waysOfCommunication_PL from '../../translations/pl_PL/blog/waysOfCommunication.json';
import whatIsLoriiniTest_PL from '../../translations/pl_PL/blog/whatIsLoriiniTest.json';

import agreement_EN from '../../translations/en_GB/blog/agreement.json';
import colorTheory_EN from '../../translations/en_GB/blog/colorTheory.json';
import effectiveCommunication_EN from '../../translations/en_GB/blog/effectiveCommunication.json';
import howInterprateResult_EN from '../../translations/en_GB/blog/howInterprateResult.json';
import manipulation_EN from '../../translations/en_GB/blog/manipulation.json';
import privacy_policy_EN from '../../translations/en_GB/blog/privacy-policy.json';
import waysOfCommunication_EN from '../../translations/en_GB/blog/waysOfCommunication.json';
import whatIsLoriiniTest_EN from '../../translations/en_GB/blog/whatIsLoriiniTest.json';

const blog = {
    agreements: {
        'en_GB': agreement_EN,
        'pl_PL': agreement_PL
    },
    colorTheory: {
        'en_GB': colorTheory_EN,
        'pl_PL': colorTheory_PL
    },
    effectiveCommunication: {
        'en_GB': effectiveCommunication_EN,
        'pl_PL': effectiveCommunication_PL
    },
    howInterprateResult: {
        'en_GB': howInterprateResult_EN,
        'pl_PL': howInterprateResult_PL
    },
    manipulation: {
        'en_GB': manipulation_EN,
        'pl_PL': manipulation_PL
    },
    privacy_policy: {
        'en_GB': privacy_policy_EN,
        'pl_PL': privacy_policy_PL
    },
    waysOfCommunication: {
        'en_GB': waysOfCommunication_EN,
        'pl_PL': waysOfCommunication_PL
    }, 
    whatIsLoriiniTest: {
        'en_GB': whatIsLoriiniTest_EN,
        'pl_PL': whatIsLoriiniTest_PL
    },
}

function* onGetDataBlogSaga({payload}) {
    try {
        // call to api
        // const response = yield call(fetch, 'http://localhost:8080/agreement');
        // const agreementData = yield response.json();
        // put response to store

        const language = yield select((state) => state.language);

        // console.log(payload,language, blog[payload][language]);
        // console.log(blog.colorTheory.en_GB);
        yield put(actionCreators.put(blog[payload][language], payload));
    }
    catch (error) {
        yield put(actionCreators.put(null));
    }
}

function* getDataBlogSaga() {
    yield takeEvery(GET_DATA_BLOG, onGetDataBlogSaga);
}

export function* dataBlogSaga() {
    yield all([fork(getDataBlogSaga)]);
}
